import { render, staticRenderFns } from "./RequisitionCard.vue?vue&type=template&id=3dae1a1e&scoped=true"
import script from "./RequisitionCard.vue?vue&type=script&lang=js"
export * from "./RequisitionCard.vue?vue&type=script&lang=js"
import style0 from "./RequisitionCard.vue?vue&type=style&index=0&id=3dae1a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae1a1e",
  null
  
)

export default component.exports